/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaCheckCircle2: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="checkCircle2" viewBox="0 0 24 24">
      <path
        d="M20.9999 11.076C20.9999 10.524 21.4479 10.076 21.9999 10.076C22.5519 10.076 22.9999 10.524 22.9999 11.076V12.007C22.9969 16.879 19.7909 21.168 15.1189 22.549C10.4469 23.93 5.42389 22.074 2.77189 17.987C0.120886 13.9 0.472886 8.55603 3.63789 4.85303C6.80289 1.15003 12.0269 -0.0309749 16.4769 1.95203C16.9809 2.17703 17.2079 2.76803 16.9829 3.27203C16.7579 3.77603 16.1669 4.00303 15.6629 3.77803C12.0219 2.15603 7.74789 3.12103 5.15789 6.15103C2.56789 9.18103 2.27989 13.553 4.44889 16.897C6.61789 20.241 10.7289 21.759 14.5509 20.629C18.3729 19.499 20.9969 15.989 20.9989 12.004V11.074L20.9999 11.076ZM11.9999 12.592L22.2929 2.29903C22.6839 1.90803 23.3169 1.90803 23.7069 2.29903C24.0969 2.69003 24.0979 3.32303 23.7069 3.71303L12.7069 14.713C12.3159 15.104 11.6829 15.104 11.2929 14.713L8.29289 11.713C7.90189 11.322 7.90189 10.689 8.29289 10.299C8.68389 9.90902 9.31689 9.90802 9.70689 10.299L11.9999 12.592Z"
        fill="#6BA342"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaCheckCircle2)
